import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_77b43f6e from 'nuxt_plugin_plugin_77b43f6e' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginrouting_bdbeb4f2 from 'nuxt_plugin_pluginrouting_bdbeb4f2' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7a1ae970 from 'nuxt_plugin_pluginmain_7a1ae970' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_sentryserver_fe743cba from 'nuxt_plugin_sentryserver_fe743cba' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_1b0c701b from 'nuxt_plugin_sentryclient_1b0c701b' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_templatesplugin6dcabe8c_397a55f5 from 'nuxt_plugin_templatesplugin6dcabe8c_397a55f5' // Source: ./templates.plugin.6dcabe8c.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_69397287 from 'nuxt_plugin_cookieuniversalnuxt_69397287' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_deviceplugin_ba288d2c from 'nuxt_plugin_deviceplugin_ba288d2c' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_googlegtag_62968764 from 'nuxt_plugin_googlegtag_62968764' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_axios_e5b11e42 from 'nuxt_plugin_axios_e5b11e42' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../../plugins/axios (mode: 'all')
import nuxt_plugin_swiper_3a1c5924 from 'nuxt_plugin_swiper_3a1c5924' // Source: ../../plugins/swiper (mode: 'all')
import nuxt_plugin_paginate_2695a1ed from 'nuxt_plugin_paginate_2695a1ed' // Source: ../../plugins/paginate (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../../plugins/i18n (mode: 'client')
import nuxt_plugin_layout_545db3c0 from 'nuxt_plugin_layout_545db3c0' // Source: ../../plugins/layout (mode: 'client')
import nuxt_plugin_vuemasonry_087bf870 from 'nuxt_plugin_vuemasonry_087bf870' // Source: ../../plugins/vue-masonry (mode: 'client')
import nuxt_plugin_vuecoollightbox_34b89388 from 'nuxt_plugin_vuecoollightbox_34b89388' // Source: ../../plugins/vue-cool-lightbox (mode: 'client')
import nuxt_plugin_vtooltip_74057214 from 'nuxt_plugin_vtooltip_74057214' // Source: ../../plugins/v-tooltip (mode: 'client')
import nuxt_plugin_preloader_2d7285c0 from 'nuxt_plugin_preloader_2d7285c0' // Source: ../../plugins/preloader (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"region":"tw","lang":"zh-Hant"},"title":"《天涯明月刀M - Garena》","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, viewport-fit=cover"},{"hid":"description","name":"description","content":"《天涯明月刀 M - Garena》演繹了 MMORPG 手遊中最頂尖的表現，如畫卷般瑰麗的光影場景、可微調數值最細緻的捏臉系統、八荒門派交織出暢快的連招戰鬥，多分支多結局由你決定故事劇情。你的選擇沒有界限，我的天涯，不只武俠！"},{"property":"og:title","content":"《天涯明月刀M - Garena》"},{"property":"og:description","content":"《天涯明月刀 M - Garena》演繹了 MMORPG 手遊中最頂尖的表現，如畫卷般瑰麗的光影場景、可微調數值最細緻的捏臉系統、八荒門派交織出暢快的連招戰鬥，多分支多結局由你決定故事劇情。你的選擇沒有界限，我的天涯，不只武俠！"},{"property":"og:image","content":"https:\u002F\u002Fdlgarenanow-a.akamaihd.net\u002Fmgames\u002Fmbmtw\u002Fh5\u002F20210512_official\u002Fmeta_image.jpg"},{"property":"og:site_name","content":"《天涯明月刀M - Garena》"},{"name":"google-site-verification","content":"vswj1auicEzKZcFVswaYQbDJINf49gCRisL8gJOPnIo"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Fdl.mbmtw.cdn.garenanow.com\u002Fh5\u002Ffooter\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Noto+Serif+TC&family=Roboto&family=Righteous&display=swap&subset=chinese-traditional","onload":"this.onload=null;this.rel='stylesheet'"}],"script":[{"src":"https:\u002F\u002Ftopbar.garena.tw\u002Fjs\u002Fapp.js","async":true},{"src":"https:\u002F\u002Ffooter.garena.tw\u002Fjs\u002Fapp.js","defer":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-MM57B3YWMK","async":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_77b43f6e === 'function') {
    await nuxt_plugin_plugin_77b43f6e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_bdbeb4f2 === 'function') {
    await nuxt_plugin_pluginrouting_bdbeb4f2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7a1ae970 === 'function') {
    await nuxt_plugin_pluginmain_7a1ae970(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_fe743cba === 'function') {
    await nuxt_plugin_sentryserver_fe743cba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_1b0c701b === 'function') {
    await nuxt_plugin_sentryclient_1b0c701b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin6dcabe8c_397a55f5 === 'function') {
    await nuxt_plugin_templatesplugin6dcabe8c_397a55f5(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_69397287 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_69397287(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_ba288d2c === 'function') {
    await nuxt_plugin_deviceplugin_ba288d2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_62968764 === 'function') {
    await nuxt_plugin_googlegtag_62968764(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_e5b11e42 === 'function') {
    await nuxt_plugin_axios_e5b11e42(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_3a1c5924 === 'function') {
    await nuxt_plugin_swiper_3a1c5924(app.context, inject)
  }

  if (typeof nuxt_plugin_paginate_2695a1ed === 'function') {
    await nuxt_plugin_paginate_2695a1ed(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_layout_545db3c0 === 'function') {
    await nuxt_plugin_layout_545db3c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemasonry_087bf870 === 'function') {
    await nuxt_plugin_vuemasonry_087bf870(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecoollightbox_34b89388 === 'function') {
    await nuxt_plugin_vuecoollightbox_34b89388(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtooltip_74057214 === 'function') {
    await nuxt_plugin_vtooltip_74057214(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_preloader_2d7285c0 === 'function') {
    await nuxt_plugin_preloader_2d7285c0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.3.4/src/history/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 1 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
